import IFlyWeight from './IFlyWeight';

/**
 * @description 享元工厂类，用来生成自定义的享元工厂
 * @author zhongzhong
 * @date 2021-03-22
 * @class Factory
 * @template T 享元的类类型
 * @template O 享元的类构造函数的参数类型
 */
class Factory<T, O extends {}> {
    /**
     * @description 享元缓存池
     * @protected
     */
    protected pools: Map<string, T>;

    private maxPoolSize = 10000;

    public constructor(private ctor: IFlyWeight<T, O>) {
        this.pools = new Map();
    }

    /**
     * @description 创建对象实例的方法
     * @author zhongzhong
     * @date 2021-03-23
     * @param {O} [options] 构造函数参数
     * @returns {T} 返回实例的类型
     */
    // @ts-ignore 先ignore，兼容很多地方没有传参数的问题
    public createInstance(options: O = {}): T {
        const handledOptions = (this.ctor.preHandleOptions?.(options)) || options;
        const key = this.ctor.generateKey(handledOptions);
        let value = this.pools.get(key);
        if (!value) {
            // console.log(`key=${key}不存在，创建一个新对象。`);
            value = new this.ctor(handledOptions, key);
            this.set(key, value);
        }
        return value;
    }

    /**
     * @description 判断传入的参数是否为 T 类型
     * @author zhongzhong
     * @date 2021-03-25
     * @param {*} obj 需要判断的参数
     * @returns {boolean} 是否为 T 类型
     */
    public isTargetType(obj: any): obj is T {
        return obj instanceof this.ctor;
    }

    public releasePools() {
        this.pools.clear();
    }

    private set(key: string, target: T) {
        if (this.pools.size >= this.maxPoolSize) {
            this.releasePools();
        }
        this.pools.set(key, target);
    }
}

export default Factory;

